import {ComboBoxItemType} from "../ComboBoxTypes"
import ToggleSwitch from "../../Toggle/ToggleSwitch";
import {InputSize, ToggleType} from "../../../../Data/Enums/Generic";
import React from "react";

const ComboBoxItemToggle = (props: ComboBoxItemType) => {
    return (
        <ToggleSwitch
            name={props.name}
            label={props.item.label}
            size={InputSize.Small}
            type={ToggleType.Checkbox}
            onKeyDown={(e: any) => props.onKeyDownCallback(e)}
            isChecked={props.selectedValues && props.selectedValues.includes(props.item.value) && !props.indeterminateValues?.includes(props.item.value)}
            isIndeterminate={props.indeterminateValues?.includes(props.item.value)}
            hideValidation={true}
            onChange={(e: any) => props.onChangeCallback(e, props)} />
    )
}

export default ComboBoxItemToggle

